import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NavParams, PopoverController, ToastController } from '@ionic/angular';
import { DataManagementService } from '../../../data-management/data-management.service';
import { Subscription } from 'rxjs';
import { Vehicule, Group } from 'src/app/model/data-managemnt';
import { RealTimeRecord } from 'src/app/model/real-time';
import { HistoricalService } from '../../historical.service';
import { SearchStepperComponent } from 'src/app/shared/components/search-stepper/search-stepper.component';
import { GeocodingService } from 'src/app/utils/leaflet/service/geocoding.service';
import { RealtimeWorkerService } from 'src/app/pages/realtime/realtime-worker.service';
import { RealTimeService } from 'src/app/pages/realtime/realtime.service';

@Component({
  selector: 'app-overspeed-modal',
  templateUrl: './overspeed-modal.component.html',
  styleUrls: ['./overspeed-modal.component.scss'],
})
export class OverspeedModalComponent implements OnInit {

  @Input() showContent:any;
  modalTitle: string;
  modelId: number;
  //groups: Group[];
  //selectedGroup: Group = new Group();
  //selectedVehicule: Vehicule | null;
  AllGroups: Subscription;
  AllOverspeeds: Subscription;

  @ViewChild(SearchStepperComponent, { static: false }) calendarModalComponent: SearchStepperComponent;
  constructor(
    private popoverController: PopoverController,
    private navParams: NavParams, public historicalService: HistoricalService,
    public toastr: ToastController, private geocodingService: GeocodingService,
    public dataManagementService: DataManagementService, private realTimeService: RealTimeService,
    private realTimeWorker: RealtimeWorkerService
  ) { }

  ngOnInit() {
    this.modelId = this.navParams.data.paramID;
    this.modalTitle = this.navParams.data.paramTitle;

    if (this.dataManagementService.groups) {
      this.dataManagementService.groups = this.dataManagementService.groups.filter(
        group => group.vehicules.length > 0
      );
      if (this.dataManagementService.selectedGroup) {
        if (this.dataManagementService.selectedVehicule) {
        } else if (this.dataManagementService.selectedGroup.vehicules.length > 0) {
          this.dataManagementService.selectedVehicule = this.dataManagementService.selectedGroup.vehicules[0];
        }
      } else {
        if (this.dataManagementService.groups.length > 0 && this.dataManagementService.groups) {
          this.dataManagementService.selectedGroup = this.dataManagementService.groups[0];
        }
      }
      this.dataManagementService.selectedVehicule = this.dataManagementService.selectedVehicule;
    } else {
      this.AllGroups = this.dataManagementService
        .getAllGroupsDetails("")
        .subscribe(groups => {
          this.dataManagementService.groups.forEach(group => {
            group.vehicules.forEach(vehicule => {
              vehicule.realTimeRecord = new RealTimeRecord();
              this.realTimeService.getRealTimeRecord(vehicule.idDevice).subscribe(x => {

                vehicule.realTimeRecord = x;

              }, (err) => {

              });
            });
          });

          this.dataManagementService.groups = groups.filter((group: any) => group.vehicules.length > 0);
          this.dataManagementService.groups = groups;
          if (this.dataManagementService.groups.length > 0 && this.dataManagementService.groups) {
            this.dataManagementService.selectedGroup = this.dataManagementService.groups[0];
            if (this.dataManagementService.selectedGroup && this.dataManagementService.selectedGroup.vehicules.length > 0) {
              this.dataManagementService.selectedVehicule = this.dataManagementService.selectedGroup.vehicules[0];
            }
          }
        });
    }
  }

  chooseVehicule(vehicule: any) {
    this.dataManagementService.setSelectedVehicle(vehicule, this.dataManagementService.selectedGroup);
    this.realTimeWorker.applyHistoriqueVehicleSelection(vehicule, this.dataManagementService.selectedGroup);
  }

  chooseGroup(group: any) {
    if (group?.vehicules?.length) {
      const vehicule = group.vehicules[0];
      this.dataManagementService.setSelectedVehicle(vehicule, group);
      this.realTimeWorker.applyHistoriqueVehicleSelection(vehicule, group);
    } else {
      this.dataManagementService.selectedGroup = group;
    }
  }


  async closePopover() {
    await this.popoverController.dismiss(undefined, 'search-done', 'historique-search-popover').catch(() => undefined);
  }

  getAllOverspeeds() {
    this.historicalService.startDate = new Date(this.calendarModalComponent.startDate);
    this.historicalService.endDate = new Date(this.calendarModalComponent.endDate);
    this.historicalService.getAllOverSpeedRoutine();
    const vehicule = this.dataManagementService.selectedVehicule;
    if (vehicule) {
      this.realTimeWorker.applyHistoriqueVehicleSelection(vehicule, this.dataManagementService.selectedGroup);
    }
    this.showContent = true

  }

  async onValidate() {
    this.getAllOverspeeds();
    await this.closePopover();
  }
  
}
